import { Component, OnInit  } from '@angular/core';

@Component({
  selector: 'ap-rightsidebar',
  templateUrl: './rightsidebar.component.html'
})
export class RightSidebarComponent {
	constructor() {}
	ngOnInit() {
		
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/shared/right-sidebar/rightsidebar.component.ts